import Form from 'components/Form';
import Layout from 'containers/Layout';
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { width } from 'styles/variables';
import Meta from 'utils/Meta';
import { navigate } from 'gatsby';
import { log, fblog } from 'utils/log';
import firebase from 'gatsby-plugin-firebase';
import cookie from 'react-cookies';
import axios from 'axios';

const Survey = styled.div`
	width: 100%;
	max-width: ${width.small}px;
	margin: 0 auto;
`;

export default props => {
	const [meta] = useState(require(`data/meta`));
	const [survey, setSurvey] = useState(require(`data/survey`));
	const [QuizExperiment, setQuizExperiment] = useState(false);

	useEffect(() => {
		// const qe = window._exps['QuizQuestions'] === 1;
		// setQuizExperiment(qe);
		let newForm = { ...getForm };
		let newData = [];
		newForm.data = newForm.data.map((item, index) => {
			// if (item.test && !qe) {
			if (item.test) {
				return false;
			}
			item.subtitle = item.subtitle_2.toUpperCase();
			return item;
		});
		newForm.data = newForm.data.filter(item => item);
		setForm(newForm);
	}, []);

	let formData = [];

	survey.steps.map((item, index) => {
		let json;
		try {
			json = JSON.parse(item.form[0].text);
		} catch (e) {
			json = false;
		}

		formData.push({
			subtitle: (item.subtitle ? item.subtitle : survey.default_subtitle)
				.split('{steps_total}')
				.join(survey.steps.length)
				.split('{steps_current}')
				.join(formData.length + 1),
			subtitle_2: item.subtitle_2,
			body: item.body,
			form: json,
			test: item.test,
			button: item.button ? item.button : survey.default_button,
		});

		return true;
	});

	let [getForm, setForm] = useState(
		typeof localStorage !== 'undefined' && localStorage.getItem('form')
			? JSON.parse(localStorage.getItem('form'))
			: {
					version: 0,
					view: 0,
					calc: {},
					plan: {},
					values: {
						gender: 'female',
					},
					metric:
						typeof window !== 'undefined' &&
						typeof window.__locale !== 'undefined' &&
						window.__locale.units === 'metric'
							? true
							: false,
					data: formData,
			  },
	);

	const form = {
		get: getForm,
		units: e => {
			e.preventDefault();
			log('Onboarding', 'Toggle', `units_${form.get.metric === true ? 'imperial' : 'metric'}`);
			let newForm = JSON.parse(JSON.stringify(getForm));
			newForm.version = Number(newForm.version) + 1;
			newForm.metric = !newForm.metric;
			newForm.values.metric = newForm.metric;
			form.store(newForm);
			setForm(newForm);
		},
		set: (dataIndex, formIndex, value) => {
			let newForm = JSON.parse(JSON.stringify(getForm));
			newForm.data[dataIndex].form.data[formIndex].value = value;
			if (newForm.data[dataIndex].form.type === 'singlechoice') {
				newForm.data[dataIndex].form.data.map((item, index) => {
					newForm.data[dataIndex].form.data[index].value = formIndex === index;
					return true;
				});
			}
			newForm.version = Number(newForm.version) + 1;

			newForm.values = {};
			newForm.data.map((item, index) => {
				item.form &&
					item.form.data.map((item, index) => {
						newForm.values[item.name] = item.value;
						return true;
					});
				return true;
			});

			newForm.calc = {};
			let values = newForm.values;
			let v;

			if (values.weight_current > 0 && values.height > 0) {
				v = Math.round((values.weight_current / Math.pow(values.height / 100, 2)) * 10) / 10;
			} else {
				v = null;
			}
			newForm.calc.bmi_value = v;

			const bmiv = newForm.calc.bmi_value;
			if (!bmiv) {
				v = null;
			} else if (bmiv < 18.5) {
				v = 'Underweight';
			} else if (bmiv < 24.9) {
				v = 'Normal weight';
			} else if (bmiv < 29.9) {
				v = 'Overweight';
			} else if (bmiv < 35) {
				v = 'Obesity';
			} else {
				v = 'Severe obesity';
			}
			newForm.calc.bmi_title = v;

			if (values.weight_current > 0 && values.height > 0) {
				v = { min: 0, max: 0 };
				v.min = Math.round(18.5 * Math.pow(values.height / 100, 2) * 10) / 10;
				v.max = Math.round(24.9 * Math.pow(values.height / 100, 2) * 10) / 10;
			} else {
				v = { min: null, max: null };
			}
			newForm.calc.bmi_weight = `${v.min}-${v.max}`;

			if (values.weight_current > 0 && values.height > 0) {
				v = Math.round((0.252 * values.weight_current + 0.473 * values.height - 48.3) * 10) / 10;
			} else {
				v = null;
			}
			newForm.calc.lbm = v;

			if (window.__generateWeightLossRate) {
				v = window.__generateWeightLossRate.caloriesRate;
			} else {
				if (values.weight_current > 0 && values.height > 0 && values.age > 0) {
					v = 10 * values.weight_current + 6.25 * values.height - 5 * values.age - 161;
					const factors = [1.2, 1.4, 1.6, 1.75, 2.0];
					let activity = 0;
					if (values.activity_medium) {
						activity = activity + 1;
					} else if (values.activity_high) {
						activity = activity + 2;
					}
					if (values.work_mix) {
						activity = activity + 1;
					} else if (values.work_active) {
						activity = activity + 2;
					}
					v = Math.round(v * factors[activity]);
				} else {
					v = null;
				}
			}

			newForm.calc.tdee = v;
			newForm.calc.tdee_carbs = v ? Math.round((v * 0.125) / 10) * 10 : null;
			newForm.calc.tdee_proteins = v ? Math.round((v * 0.6) / 10) * 10 : null;
			newForm.calc.tdee_fats = v ? v - newForm.calc.tdee_carbs - newForm.calc.tdee_proteins : null;

			newForm.calc.water = window.__generateWeightLossRate
				? Math.round((window.__generateWeightLossRate.waterRate / 1000) * 10) / 10
				: 2.2; // Male = 3.0
			newForm.calc.steps = window.__generateWeightLossRate ? window.__generateWeightLossRate.stepsRate : 10000; // recommended

			if (Number(values.weight_current) > 0 && Number(values.weight_desired) > 0) {
				let weightCurrent = values.weight_current;
				let weightDesired = values.weight_desired;
				let weightLost = weightCurrent - weightDesired;
				let weightUnits = 'kg';
				if (!newForm.metric) {
					weightCurrent = Math.round(weightCurrent * 2.20462262185 * 10) / 10;
					weightDesired = Math.round(weightDesired * 2.20462262185 * 10) / 10;
					weightLost = Math.round(weightLost * 2.20462262185 * 10) / 10;
					weightUnits = 'lbs';
				}
				newForm.calc.goalLost = weightLost + weightUnits;
				newForm.calc.goal = weightDesired + weightUnits;
			}

			const focusZones = [];
			[
				{ n: 'chest', v: '0' },
				{ n: 'belly', v: '1' },
				{ n: 'legs', v: '2' },
				{ n: 'arms', v: '3' },
				{ n: 'butt', v: '4' },
				{ n: 'full', v: '5' },
			].forEach((item, index) => {
				if (newForm.values[`areas_${item.n}`]) {
					focusZones.push(item.v);
				}
			});

			clearTimeout(window.__generateWeightLossRateTimeout);
			window.__generateWeightLossRateTimeout = setTimeout(() => {
				firebase
					.functions()
					.httpsCallable('generateWeightLossRate')({
						jobId: newForm.values.work_inactive
							? '0'
							: newForm.values.work_active
							? '1'
							: newForm.values.work_mix
							? '2'
							: '',
						startedWeight: Number(newForm.values.weight_current),
						targetWeight: Number(newForm.values.weight_desired),
						height: Number(newForm.values.height),
						age: Number(newForm.values.age),
						activityLevel: newForm.values.activity_high
							? '0'
							: newForm.values.activity_medium
							? '1'
							: newForm.values.activity_low
							? '2'
							: '',
					})
					.then(function(result) {
						window.__generateWeightLossRate = result.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			}, 300);

			form.store(newForm);
			setForm(newForm);
		},
		back: () => {
			let newForm = JSON.parse(JSON.stringify(getForm));
			newForm.view = Number(newForm.view) - 1;
			newForm.version = Number(newForm.version) + 1;
			if (newForm.view > -1) {
				form.store(newForm);
				setForm(newForm);
			} else {
				navigate('/');
			}
		},
		next: e => {
			if (typeof form.get.data[form.get.view].form.name != 'undefined') {
				log('Onboarding', 'View', form.get.data[form.get.view].form.name);
				fblog('trackCustom', form.get.data[form.get.view].form.name + '_selected');
				let obj = {};
				for (var key in form.get.values) {
					if (form.get.values[key] === true) {
						log('Overview', 'Profile', key);
						fblog('trackCustom', 'overview_' + key);
						if (key.split('_').length) {
							obj[key.split('_')[0]] = key.split('_')[1];
						} else {
							obj[key.split('_')[0]] = key.split('_')[1];
						}
					} else if (typeof form.get.values[key] === 'string' || typeof form.get.values[key] === 'number') {
						obj[key] = form.get.values[key];
					}
				}
				// axios
				// 	.post('/.netlify/functions/sheet', {
				// 		data: { ...obj, id: cookie.load('uid') },
				// 		sheetName:
				// 			process.env.NODE_ENV === 'production' &&
				// 			!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
				// 				? form.get.data[form.get.view].form.name
				// 				: '_dev_' + form.get.data[form.get.view].form.name,
				// 	})
				// 	.then(e => true);
			}
			let newForm = JSON.parse(JSON.stringify(getForm));
			newForm.view = Number(newForm.view) + 1;
			newForm.version = Number(newForm.version) + 1;
			if (newForm.view === newForm.data.length && newForm.values.platform_android === true) {
				navigate('/android');
			} else if (newForm.view === newForm.data.length) {
				let id = localStorage.getItem('id');
				if (id) {
					navigate(`/overview?id=${id}`);
				} else {
					navigate('/overview');
				}
			} else {
				form.store(newForm);
				setForm(newForm);
			}
		},
		store: data => {
			typeof localStorage !== 'undefined' && localStorage.setItem('form', JSON.stringify(data));
		},
	};

	return (
		<>
			<Meta />
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'WebPage',
						url: meta.domain,
						name: meta.title,
						description: meta.description,
					})}
				</script>
			</Helmet>
			<Layout>
				<Survey>
					{form.get.data.map((item, index) => (
						<Form form={form} index={index} key={index} />
					))}
				</Survey>
			</Layout>
		</>
	);
};
